/* Product pairings — tabbed (BL). Boolland custom.
   ARIA tablist: click / arrow-key switching between category panels.
   No-ops when there are no tabs (single-category layout). */
(function () {
  if (customElements.get('bl-pairings-tabs')) return;

  class BlPairingsTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.tabs.length < 2) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });
    }

    select(tab) {
      const name = tab.getAttribute('data-bl-pt-tab');
      this.tabs.forEach((current) => {
        const selected = current === tab;
        current.setAttribute('aria-selected', selected ? 'true' : 'false');
        current.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        if (panel.getAttribute('data-bl-pt-panel') === name) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    onKeydown(event) {
      const index = this.tabs.indexOf(event.target);
      if (index < 0) return;
      let next = null;
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = this.tabs[(index + 1) % this.tabs.length];
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
          break;
        case 'Home':
          next = this.tabs[0];
          break;
        case 'End':
          next = this.tabs[this.tabs.length - 1];
          break;
        default:
          return;
      }
      if (next) {
        event.preventDefault();
        this.select(next);
        next.focus();
      }
    }
  }

  customElements.define('bl-pairings-tabs', BlPairingsTabs);
})();
